import { ChevronLeft, X } from "lucide-react";
import { NavLink } from "react-router-dom";
import { LucideIcon } from "lucide-react";

interface SubmenuItem {
  title: string;
  url: string;
  icon: LucideIcon;
}

interface MobileSubmenuPanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  items: SubmenuItem[];
  onNavigate: () => void;
  getNavClassName: (url: string) => string;
}

export function MobileSubmenuPanel({
  isOpen,
  onClose,
  title,
  items,
  onNavigate,
  getNavClassName,
}: MobileSubmenuPanelProps) {
  if (!isOpen) return null;

  const handleItemClick = () => {
    onNavigate();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] md:hidden">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60" 
        onClick={onClose}
      />
      
      {/* Panel qui glisse depuis la droite */}
      <div 
        className={`absolute top-0 right-0 h-full w-[85%] max-w-[320px] bg-[#0A2540] shadow-2xl transform transition-transform duration-300 ease-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header du panneau */}
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <button 
            onClick={onClose}
            className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
          >
            <ChevronLeft className="h-5 w-5" />
            <span className="text-sm">Retour</span>
          </button>
          <h2 className="text-[#F57C00] font-semibold text-sm">{title}</h2>
          <button 
            onClick={onClose}
            className="p-1 text-gray-400 hover:text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        {/* Liste des sous-éléments */}
        <div className="p-3 overflow-y-auto h-[calc(100%-60px)]">
          <nav className="space-y-1">
            {items.map((item) => (
              <NavLink
                key={item.title}
                to={item.url}
                onClick={handleItemClick}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-all duration-200 ${getNavClassName(item.url)}`}
              >
                <item.icon className="h-5 w-5 shrink-0" />
                <span>{item.title}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
